import React, { FC } from 'react';
import styled from 'styled-components';
import WarningIcon from '@mui/icons-material/Warning';
import { useTranslation } from 'react-i18next';
import { Order } from '../../../common/model/dto/order/order';
import { OrderDataUtils } from '../../../common/utils/services/order-data-utils';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

const OvOrderDiscount: FC<{ order: Order }> = ({ order }) => {
  const { t } = useTranslation();
  const discountTotal = OrderDataUtils.getDiscountTotal(order);
  const hasCode = !!order.discount_code?.trim();

  return (
    <>
      {hasCode && <Line>{order.discount_code}</Line>}
      {!hasCode && discountTotal > 0 && (
        <MissingCode>
          <WarningIcon aria-hidden="true" />
          {t('orders.missingCode')}
        </MissingCode>
      )}
      <Line>
        {discountTotal > 0
          ? `−${OrderDataUtils.formatAmount(discountTotal)}`
          : t('orders.noDiscount')}
      </Line>
    </>
  );
};

export default OvOrderDiscount;

const Line = styled.span`
  display: block;
  color: ${Colours.OV_CHARCOAL};
  font-size: ${Variables.fontSizes.SMALL};
  overflow-wrap: break-word;
`;

const MissingCode = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: ${Colours.OV_BASE};
  font-size: ${Variables.fontSizes.SMALL};
  font-weight: bold;
  white-space: nowrap;

  .MuiSvgIcon-root {
    width: 0.875rem;
    height: 0.875rem;
  }
`;
